import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import FilledInput from '@mui/material/FilledInput';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import SendIcon from '@mui/icons-material/Send';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import DatePicker from 'react-datepicker';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Divider from '@mui/material/Divider';
import "react-datepicker/dist/react-datepicker.css";
import dayjs from 'dayjs';
import FormHelperText from '@mui/material/FormHelperText';
import Input from '@mui/material/Input';
import { styled } from '@mui/material/styles';
import SaveIcon from '@mui/icons-material/Save';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';
import { DataGrid } from '@mui/x-data-grid';
import OutlinedInput from '@mui/material/OutlinedInput';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import apiClient from '../ApiClient/ApiClient';

const classChoose = [
    {
      value: '客供入庫',
      label: '客供入庫',
    },
    {
      value: '客供取消',
      label: '客供取消',
    },
    {
      value: '材料需求',
      label: '材料需求',
    },
    {
      value: '盤盈',
      label: '盤盈',
    },
    {
      value: '盤虧',
      label: '盤虧',
    },
    {
      value: '報廢',
      label: '報廢',
    },
    {
      value: '不良品',
      label: '不良品',
    },
    {
      value: '',
      label: '不選擇',
    },
  ];


export default function StockChange({data}) {
  
  const columns = [
    { field: 'id', headerName: 'ID', width:80 },
    {
        field: 'classModel',
        headerName: '類別',
        width: 110,
        editable: true,
    },
    {
        field: 'piNum',
        headerName: '批號',
        width: 170,
        editable: true,
    },
    {
      field: 'date',
      headerName: '日期',
      width: 140,
      editable: true,
      valueFormatter: (params) => params.value ? dayjs(params.value).format('YYYY/MM/DD') : ''
    },
    {
        field: 'drawNum',
        headerName: '圖號',
        sortable: false,
        width: 160,
        editable: true,
    },
    {
        field: 'qty',
        headerName: '數量',
        sortable: false,
        width: 80,
        editable: true,
    },
    {
        field: 'applicant',
        headerName: '申請人',
        sortable: false,
        width: 190,
        editable: true,
    },
    {
      field: 'signOff',
      headerName: '簽核',
      width: 250,
      sortable: false,
      editable: true,
      renderCell: (params) => {
        if (params.value) {
          // If there's a value, just display it
          return <span>{params.value}</span>;
        } 
          return (
            <>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ marginLeft: 16 }}
                onClick={(e) => { e.stopPropagation(); handleApprove(params.id); }}

              >
                通過
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                size="small"
                style={{ marginLeft: 16 }}
                onClick={(e) => { e.stopPropagation(); handleReject(params.id); }}
              >
                拒絕
              </Button>
            </>
          );
        
      },
    },
    {
        field: 'signOffdDate',
        headerName: '簽核日期',
        sortable: false,
        width: 160,
        editable: true,
    },
    ];
    const [loading, setLoading] = useState(false); // 加入 loading 狀態
    const [rows, setRows] = React.useState([]);
    const [classValue, setClassValue] = useState('客供入庫');
    const [date, setDate] = useState('');
    const [piNum, setPiNum] = useState('');
    const [drawNo, setDrawNo] = useState('');
    const [qty, setQty] = useState(null);
    const [isCreate,setIsCreate] = useState(false);
    const [detailOpen, setDetailOpen] = useState(false);
    const [detailLoading, setDetailLoading] = useState(false);

    // 補交紀錄：單筆
    const [reDelivery, setReDelivery] = useState(null);

    // 出貨資料：多筆(<=3)
    const [shipments, setShipments] = useState([]);
    useEffect(() => {
        if (data && data.stoChanges) {
          setRows(data.stoChanges);
        }
      }, [data]); 


    const handleSearch = async () => {
      setLoading(true);
    try {
        const response = await apiClient.get(`/Storage/GetChanges?classModel=${classValue}&date=${date}&piNum=${piNum}&drawNum=${drawNo}`);
        if(response.data.stoChanges != null) {
        setRows(response.data.stoChanges);
        alert('搜尋成功');
        }else {
        alert('找無資料');
        }

    } catch (error) {
        console.error('Failed to fetch user data:', error);
        alert('找無資料');
    }finally{
      setLoading(false);
    }
    };  

    const handleApprove =async (id) => {
      setLoading(true);
      try {
        const user = sessionStorage.getItem('userName');
        const response = await apiClient.get(`/Storage/Approve?id=${id}&name=${user}`);
        if(response.status === 200) {
          handleSearchNotYet();
        }else {
          alert('失敗');
        }

      } catch (error) {
          console.error('Failed to fetch user data:', error);
          alert('失敗');
      }finally{
        setLoading(false);
      }
    };
    
    const handleReject = async(id) => {
      setLoading(true);
      try {

        const response = await apiClient.get(`/Storage/Reject?id=${id}`);
        if(response.status === 200) {
          handleSearchNotYet();
        }else {
          alert('失敗');
        }

      } catch (error) {
          console.error('Failed to fetch user data:', error);
          alert('失敗');
      }finally{
        setLoading(false);
      }
    };

    const handleRowClick = async (params, event) => {
      // 如果你點的是按鈕(通過/拒絕)，避免也觸發 row click
      // (搭配下面按鈕 stopPropagation，會更穩)
      if (event?.defaultMuiPrevented) return;
    
      const rowId = params.id;
      setDetailOpen(true);
      setDetailLoading(true);
    
      try {
        const resp = await apiClient.get(`/Storage/GetReDeliveryDetail`, {
          params: { id: rowId },
        });
    
        // 後台回傳格式：{ reDelivery: {...} | null, shipments: [...] }
        setReDelivery(resp.data.reDelivery || null);
        setShipments(resp.data.shipments || []);
      } catch (err) {
        console.error(err);
        alert('讀取明細失敗');
        setReDelivery(null);
        setShipments([]);
      } finally {
        setDetailLoading(false);
      }
    };
    

    const handleSearchNotYet = async () => {
      setLoading(true);  
      try {
            const response = await apiClient.get(`/Storage/GetNotYetChanges`);
            if(response.data.stoChanges != null) {
            setRows(response.data.stoChanges);
            alert('搜尋成功');
            }else {
            alert('搜尋失敗');
            }
    
        } catch (error) {
            console.error('Failed to fetch user data:', error);
            alert('搜尋失敗');
        }finally{
          setLoading(false);
        }
    };  
    const handleModel = () => {
      setIsCreate(!isCreate);
      if(!isCreate) {
        // 建立一个新的Date对象，它代表当下的日期和时间
        const now = new Date();
        
        // 格式化日期为YYYY-MM-DD
        const formattedDate = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;
    
        // 设置日期
        setDate(formattedDate);
      } else {
        setDate('');
      }
    };
    
    
  
    const handleAddSave = async () => {
      setLoading(true);  
      try {
          const user = sessionStorage.getItem('userName'); // 获取存储在SESSION中的USER
          const classModel = classValue;
          if(isCreate && classValue === '') {
            alert('類別要選擇');
            return;
          }
          const response = await apiClient.post(`/Storage/CreateChange`, {
            classModel,
            date,
            piNum,
            drawNo,
            qty,
            user,
          });

          if (response.data.statusCode) {
            alert('添加成功');
            // 可以在这里添加其他成功的处理逻辑
          } else {
            alert('添加失败');
          }
        } catch (error) {
          console.error('Failed to add data:', error);
          alert('添加失败');
        }finally{
          setLoading(false);
        }
      };
    
  return (
    <>
        <Box
        component="form"
        sx={{
            '& > :not(style)': { m: 1 },
        }}
        noValidate
        autoComplete="off"
        >
          <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
        <TextField
            id="outlined-select-currency-native"
            select
            label="類別Class"
            defaultValue="客供入庫"
            SelectProps={{
            native: true,
            }}
            helperText="Please select your Class"
            onChange={(e)=>setClassValue(e.target.value)}
            value={classValue}
        >
            {classChoose.map((option) => (
            <option key={option.value} value={option.value}>
                {option.label}
            </option>
            ))}
        </TextField>
        <FormControl>
          <InputLabel shrink htmlFor="date-picker">日期Date</InputLabel>
          <DatePicker
            id="date-picker"
            selected={date ? new Date(date) : null}
            onChange={d => {
              // 用 dayjs 格式化 yyyy-MM-dd
              setDate(d ? dayjs(d).format("YYYY/MM/DD") : "");
            }}
            dateFormat="yyyy/MM/dd"
            placeholderText="yyyy/mm/dd"
            className="form-control"
          />
        </FormControl>
        <FormControl>
            <InputLabel htmlFor="component-outlined">批號</InputLabel>
            <OutlinedInput
            onChange={(e)=>setPiNum(e.target.value)}
            value={piNum}
            id="component-outlined"
            defaultValue=""
            label="Name"
            readOnly={!isCreate}
            />
        </FormControl>
        <FormControl>
            <InputLabel htmlFor="component-outlined">圖號Draw no.</InputLabel>
            <OutlinedInput
            onChange={(e)=>setDrawNo(e.target.value)}
            value={drawNo}
            id="component-outlined"
            defaultValue=""
            label="Name"
            readOnly={!isCreate}
            />
        </FormControl>
        <FormControl>
            <InputLabel htmlFor="component-outlined">數量Qty</InputLabel>
            <OutlinedInput
            onChange={(e)=>setQty(e.target.value)}
            value={qty}
            id="component-outlined"
            defaultValue=""
            label="Name"
            placeholder='請符合資料庫格式'
            readOnly={!isCreate}
            />
        </FormControl>     
        </Box>
            <Box sx={{ height: 600, width: '100%' }}>
            <Tooltip title="Add" arrow>
                <Button endIcon={<SearchIcon />} onClick={handleSearch}>搜尋</Button>
                <Button endIcon={<AddIcon />} onClick={handleModel}>{isCreate?'新增':'搜尋'}</Button>
                <Button endIcon={<SaveIcon />} onClick={handleAddSave}>保存</Button>
                <Button endIcon={<ReceiptLongIcon/>} onClick={handleSearchNotYet}>庫存異動</Button>
            </Tooltip>
            <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
                pagination: {
                paginationModel: {
                    pageSize: 100,
                },
                },
            }}
            rowHeight={35}
            headerHeight={35}
            onRowDoubleClick={handleRowClick} 
            pageSizeOptions={[100,75,50]}
            disableRowSelectionOnClick
            sx={{
              '& .MuiDataGrid-cell': { fontSize: 18 },
              '& .MuiDataGrid-columnHeaders': { fontSize: 18 },
              '& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader': {
                paddingTop: '4px', paddingBottom: '4px'
              },
            }}
            />
            <Dialog open={detailOpen} onClose={() => setDetailOpen(false)} fullWidth maxWidth="lg">
            <DialogTitle>補交/出貨明細</DialogTitle>

            <DialogContent>
              {detailLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  {/* 補交紀錄（單筆） */}
                  <Typography variant="h6" sx={{ mb: 1 }}>補交紀錄</Typography>
                  {reDelivery ? (
                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1, mb: 2 }}>
                      <Typography>客戶：{reDelivery.客戶}</Typography>
                      <Typography>批號：{reDelivery.批號}</Typography>
                      <Typography>圖號：{reDelivery.圖號}</Typography>
                      <Typography>項次：{reDelivery.項次}</Typography>

                      <Typography>不良數：{reDelivery.不良數}</Typography>
                      <Typography>補交數：{reDelivery.補交數}</Typography>
                      <Typography>日期：{reDelivery.日期 ? dayjs(reDelivery.日期).format('YYYY/MM/DD') : ''}</Typography>
                      <Typography>訂單號碼：{reDelivery.訂單號碼}</Typography>

                      <Typography>流水號：{reDelivery.流水號}</Typography>
                      <Typography>物品名：{reDelivery.物品名}</Typography>
                      <Typography>承製公司：{reDelivery.承製公司}</Typography>
                      <Typography>ID：{reDelivery.id}</Typography>
                    </Box>
                  ) : (
                    <Typography color="text.secondary" sx={{ mb: 2 }}>查無補交紀錄</Typography>
                  )}

                  <Divider sx={{ my: 2 }} />

                  {/* 出貨資料（多筆<=3） */}
                  <Typography variant="h6" sx={{ mb: 1 }}>出貨資料</Typography>

                  <Box sx={{ height: 240, width: '100%' }}>
                    <DataGrid
                      rows={shipments}
                      getRowId={(r) => r.id ?? `${r.出貨單號}-${r.出貨日期}-${r.圖號}`} // 若後台沒回 id，可用組合 key
                      columns={[
                        { field: '出貨日期', headerName: '出貨日期', width: 130, valueFormatter: (p) => p.value ? dayjs(p.value).format('YYYY/MM/DD') : '' },
                        { field: '出貨單號', headerName: '出貨單號', width: 150 },
                        { field: '批號', headerName: '批號', width: 140 },
                        { field: '圖號', headerName: '圖號', width: 160 },
                        { field: '實交貨數', headerName: '實交貨數', width: 110 },
                      ]}
                      pageSizeOptions={[3]}
                      initialState={{ pagination: { paginationModel: { pageSize: 3 } } }}
                      rowHeight={32}
                      headerHeight={32}
                      disableRowSelectionOnClick
                    />
                  </Box>
                </>
              )}
            </DialogContent>

            <DialogActions>
              <Button onClick={() => setDetailOpen(false)}>關閉</Button>
            </DialogActions>
          </Dialog>

        </Box>   
      </>
  );
}